import * as Scrivito from "scrivito"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"

import { FollowUpConfigurationAdminPageConnector } from "pages/follow-up-configuration-admin-page/FollowUpConfigurationAdminPageConnector"

import { FollowUpConfigurationAdminPageObjClass } from "./FollowUpConfigurationAdminPageObjClass"

Scrivito.provideComponent(FollowUpConfigurationAdminPageObjClass, () => {
  useScrivitoPage()
  return <FollowUpConfigurationAdminPageConnector />
})
